import { render, staticRenderFns } from "./OsmEmissaoAvulsa.vue?vue&type=template&id=61c9fab3&scoped=true&lang=pug&"
import script from "./OsmEmissaoAvulsa.vue?vue&type=script&lang=js&"
export * from "./OsmEmissaoAvulsa.vue?vue&type=script&lang=js&"
import style0 from "./OsmEmissaoAvulsa.vue?vue&type=style&index=0&id=61c9fab3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9fab3",
  null
  
)

export default component.exports